$(() => {
  /* eslint-disable */
  window._wq = window._wq || [];
  _wq.push({
    id: '_all',
    onReady: function(video) {
      const $container = $(video.container).closest('.expand-video');
      if ($container.length) {
        const $playBtn = $container.find('.play-button');
        if ($playBtn.length) {
          $playBtn.on('click', function(e) {
            e.preventDefault();
            $container.addClass('expanded');
            video.play(); // Play the wistia video
          });
        }
        // Remove the class when the video ends
        video.bind('end', function() {
          $container.removeClass('expanded');
        });
      }
    }
  });
});
